function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import moment from 'moment';
import forEach from 'lodash/forEach';
import { injectIntl, FormattedMessage } from 'react-intl';
import StatsCalculations from 'libs/StatsCalculations';
import App from 'modules/App';
import Logo from 'svg/Ascensia-logo.svg';
import { calculateData } from 'helpers/kpi';
import intlShape from 'shapes/intlShape';
import * as constants from '../../constants';
import messages from '../../messages';
import { GlucoseConcentrationTrend } from '../../modules/Charts';
import styles from './DailyLogReport.pcss';
import Header from './Header';
import DailyChart from './DailyChart';
import Summary from './Header/Summary';
var _React_Component;
class DailyLogReport extends (_React_Component = React.Component) {
    get chartData() {
        const { readings, standards, customRanges } = this.props;
        const statsCalculations = new StatsCalculations(readings, standards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        return {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData
        };
    }
    get ticks() {
        const startDate = moment().utc().locale('en--account');
        const endDate = moment().utc().locale('en--account');
        const ticksPoints = [];
        startDate.startOf('day');
        endDate.endOf('day');
        ticksPoints.push(+startDate.format('X'));
        const breakpoints = [
            ...this.props.customRanges
        ];
        breakpoints.shift();
        forEach(breakpoints, (hourBreakpoint)=>{
            ticksPoints.push(+startDate.hour(hourBreakpoint[0]).minutes(hourBreakpoint[1]).format('X'));
        });
        ticksPoints.push(+endDate.format('X') + 1);
        return ticksPoints;
    }
    renderUnit() {
        return /*#__PURE__*/ _jsx("p", {
            className: styles.bloodGlucoseConcentrationUnit,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.unit), {
                values: {
                    unit: this.props.conversion.unitSymbol
                }
            }))
        });
    }
    renderContent() {
        const { conversion, standards, startDate, endDate, relatedData, readings, phiSet, daysWithReadings, daysWithoutReadings, hideDailyDetails } = this.props;
        const { preMeal, postMeal } = this.data;
        const gridTheme = {
            axis: {
                domain: {
                    line: {
                        strokeWidth: 0
                    }
                }
            }
        };
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.printableDailyLogReport,
            children: [
                /*#__PURE__*/ _jsx(Header, {
                    phiSet: phiSet,
                    accountPatientProfile: this.props.accountPatientProfile,
                    standards: standards,
                    conversion: conversion,
                    startDate: startDate,
                    endDate: endDate
                }),
                /*#__PURE__*/ _jsx(Summary, {
                    phiSet: phiSet,
                    readings: readings,
                    preMeal: preMeal,
                    postMeal: postMeal,
                    conversion: conversion,
                    standards: standards,
                    daysWithReadings: daysWithReadings,
                    daysWithoutReadings: daysWithoutReadings
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.standardDay__wrapper,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.standardDay,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.standardDay))
                        }),
                        this.renderUnit(),
                        /*#__PURE__*/ _jsx(GlucoseConcentrationTrend, {
                            readings: this.chartData.readings,
                            averageData: this.chartData.averageData,
                            start: startDate.unix(),
                            end: endDate.unix(),
                            ticks: this.ticks,
                            gridTheme: gridTheme,
                            isCustomRanges: true,
                            isReadOnly: true,
                            formatLabel: ()=>''
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.chart__legend,
                            children: [
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.tableCriticalHigh)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("b", {
                                            children: ` > ${conversion.toDisplay(standards.critical.highThreshold)} ${conversion.unitSymbol}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.tablePostMeal)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("b", {
                                            children: ` ${conversion.toDisplay(standards.postMeal.lowThreshold)} - ${conversion.toDisplay(standards.postMeal.highThreshold)} ${conversion.unitSymbol}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.tablePreMeal)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("b", {
                                            children: ` ${conversion.toDisplay(standards.preMeal.lowThreshold)} - ${conversion.toDisplay(standards.preMeal.highThreshold)} ${conversion.unitSymbol}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.tableCriticalLow)),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("b", {
                                            children: ` < ${conversion.toDisplay(standards.critical.lowThreshold)} ${conversion.unitSymbol}`
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !hideDailyDetails && /*#__PURE__*/ _jsx(DailyChart, {
                    readings: readings,
                    conversion: conversion,
                    standards: standards,
                    ticks: this.ticks,
                    customRanges: this.props.customRanges,
                    relatedData: relatedData,
                    timeSeriesResources: this.props.timeSeriesResources,
                    hideEmptyRows: this.props.hideEmptyRows,
                    showDayDividers: this.props.showDayDividers
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.footer,
                    children: /*#__PURE__*/ _jsx(Logo, {})
                })
            ]
        });
    }
    render() {
        if (!this.props.phiSet) return null;
        return this.renderContent();
    }
    constructor(props){
        super(props);
        this.data = calculateData(props.readings);
    }
}
_define_property(DailyLogReport, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        critical: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readings: PropTypes.array,
    relatedData: PropTypes.array,
    timeSeriesResources: PropTypes.array,
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    calculationFormula: PropTypes.oneOf(constants.CALCULATION_FORMULAS),
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    customRanges: PropTypes.array,
    daysWithReadings: PropTypes.number,
    daysWithoutReadings: PropTypes.number,
    hideDailyDetails: PropTypes.bool,
    hideEmptyRows: PropTypes.bool,
    showDayDividers: PropTypes.bool,
    // Implicit props
    featureToggles: PropTypes.array,
    intl: intlShape.isRequired
});
const mapStateToProps = (state)=>({
        featureToggles: App.selectors.featureToggles(state)
    });
const ConnectedDailyLogReport = connect(mapStateToProps)(DailyLogReport);
export default withStyles(styles)(injectIntl(ConnectedDailyLogReport));
